module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_fully_customized_style.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_fully_customized_style.png
// module id = 80em
// module chunks = 0